module.exports = __webpack_public_path__ + "static/icon-obsessed-ac03056cf87849d2a3524f1e1a80539a.png";